import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import React, { useState, useEffect } from 'react';
import { SetSessionID } from '../../hooks/SessionID';

//import { APIPost } from '../../hooks/xxxAPIFetch';

import Cookies from 'universal-cookie';

import DateBlock from '../blocks/DateBlock';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';

import GenericFormContainer from './FormContainer';


const getDaysInMonth = (year: number, month: number) => new Date(year, month, 0).getDate();

interface AgeverificationProps {
    submit: (value: boolean) => void;
}

function AgeVerificationForm({submit}: AgeverificationProps){
    var today = new Date();

    const cookies = new Cookies();
    let [dob_year, setYear] = useState(0);
    let [dob_month, setMonth] = useState(1);
    let [dob_day, setDay] = useState(0);

    const [responseMessage, setResponseMessage] = useState("");


    /* Component Init */
    useEffect(() => {
        console.log("Initializing age verification.")
        if(cookies.get('app-session')){
            submit(true);
            console.log("Age verified.")
        }
    }, []);

    const handleSubmit = async (event: React.SubmitEvent) => {
        /* Don't reload page immediately so application can wait for API response */
        event.preventDefault();

        const posturl = process.env.REACT_APP_API_URL + "/v1/session/start";
        const dobinfo = {dob_year, dob_month, dob_day};
        let axiosConfig = GetHeaders();
        

        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: dobinfo})
        console.log("Used the function...")
        console.log(response)

        //Successful response
        SetSessionID(response.session_id)
        submit(true)
    };

    return (
        <> 

            <GenericFormContainer>
                <Row className="bg-white rounded">
                    <Col>
                        <p className="text-start text-font-body text-font-size-large">Date of Birth:</p>
                        <p className="text-start text-font-body text-font-size-small">You must be over 21 to view this site. **</p>
                    </Col>
                </Row>
                <Row className="bg-white rounded">
                    <Col>
                        <form onSubmit={handleSubmit}>
                        <Row>
                            <DateBlock formPrefix='dob' outputYear={setYear} outputMonth={setMonth} outputDay={setDay} />
                        </Row>
                        <Row className="py-2">
                            <button type="submit"  className="btn brand-btn-secondary-color w-100">Continue as a Guest</button>
                        </Row>
                        </form>
                    </Col>
                </Row>
            </GenericFormContainer>
        </>
    )
}

export default AgeVerificationForm;